<template>
  <div class="user cont_bg" style="padding-bottom: 2rem">
    <navbar>
      <template #right>
        <!-- <span class="material-icons" @click="goto('/system_messages')">
          notifications_none
        </span> -->
        <svg @click="goto('/system_messages')" t="1748486708493" class="icon" viewBox="0 0 1024 1024" version="1.1"
          xmlns="http://www.w3.org/2000/svg" p-id="18639" width=".6rem" height=".6rem">
          <path
            d="M823.04 727.04L768 672v-213.333333c0-130.986667-69.973333-240.64-192-269.653334v-29.013333c0-35.413333-28.586667-64-64-64s-64 28.586667-64 64v29.013333C325.546667 218.026667 256 327.253333 256 458.666667v213.333333l-55.04 55.04c-26.88 26.88-8.106667 72.96 29.866667 72.96h561.92c38.4 0 57.173333-46.08 30.293333-72.96zM682.666667 714.666667H341.333333v-256c0-105.813333 64.426667-192 170.666667-192s170.666667 86.186667 170.666667 192v256z m-170.666667 213.333333c46.933333 0 85.333333-38.4 85.333333-85.333333h-170.666666a85.333333 85.333333 0 0 0 85.333333 85.333333z"
            p-id="18640" fill="#ffffff"></path>
        </svg>
      </template>
    </navbar>
    <div class="userinfo">
      <div class="userbody">
        <div class="top">
          <div class="avatar" @click="goto('/set_avatar')">
            <img :src="avatar" alt="">
          </div>
          <div class="right">
            <div class="phone">
              {{ userInfo?.username }}
            </div>
            <!-- <div class="code">
              <span>
                {{ $t('user.t1') }}
                {{ userInfo?.invite_code }}
              </span>
              <span class="material-icons" @click="goto('/invite_friends')">
                card_giftcard
              </span>
            </div> -->
          </div>
        </div>
        <div class="center">
          <div class="balance">
            <div class="price">
              ${{ userInfo?.balance }}
            </div>
            <div class="text">
              {{ $t('user.t2') }}
            </div>
          </div>
          <div class="btn" @click="$router.push('/recharge')">
            <span class="material-icons">
              add
            </span>
          </div>
        </div>
        <div class="bottom">
          <div class="item ">
            <div class="price green">
              ${{ userInfo?.balance }}
            </div>
            <div class="text">
              {{ $t('user.t3') }}
            </div>
          </div>
          <div class="item">
            <div class="price orange">
              <!-- ${{ userInfo?.lixibao_balance }} -->
              ${{ userInfo?.total }}
            </div>
            <div class="text">
              {{ $t('user.t4') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="index" @click="goto(item.url)">
        <div class="icon">
          <span class="material-icons">
            {{ item.icon }}
          </span>
        </div>
        <div class="r">
          <div class="txt">
            {{ item.txt }}
            <i class="material-icons">chevron_right</i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userInfo: {},
      list: [
        { icon: 'call_made', txt: this.$t('user.t5'), url: '/withdraw' },
        { icon: 'library_add', txt: this.$t('user.t6'), url: '/recharge_record' },
        { icon: 'payments', txt: this.$t('user.t7'), url: '/withdrawal_record' },
        { icon: 'repeat', txt: this.$t('user.t8'), url: '/account' },
        { icon: 'notifications', txt: this.$t('user.t9'), url: '/system_messages' },
        { icon: 'credit_card', txt: this.$t('user.t10'), url: '/bankcard' },
        { icon: 'account_balance_wallet', txt: this.$t('movie.t04'), url: '/bankwallet' },
        { icon: 'lock_open', txt: this.$t('user.t11'), url: '/editPwd' },
        { icon: 'lock_open', txt: this.$t('user.t12'), url: '/editWithdrawPwd' },
        // { icon: 'share', txt: this.$t('user.t13'), url: '/invite_friends' },
        { icon: 'language', txt: this.$t('user.t14'), url: '/lang' },
        { icon: 'power_settings_new', txt: this.$t('user.t15') },
      ],
      avatarlist: [
        {
          url: require('@/assets/image/1.png'),
        },
        {
          url: require('@/assets/image/2.png'),
        },
        {
          url: require('@/assets/image/3.png'),
        },
        {
          url: require('@/assets/image/4.png'),
        },
        {
          url: require('@/assets/image/5.png'),
        },
        {
          url: require('@/assets/image/6.png'),
        },
        {
          url: require('@/assets/image/7.png'),
        },
        {
          url: require('@/assets/image/8.png'),
        },
        {
          url: require('@/assets/image/9.png'),
        },
        {
          url: require('@/assets/image/10.png'),
        },
        {
          url: require('@/assets/image/11.png'),
        },
        {
          url: require('@/assets/image/12.png'),
        },
        {
          url: require('@/assets/image/13.png'),
        },
        {
          url: require('@/assets/image/14.png'),
        },
        {
          url: require('@/assets/image/15.png'),
        },
      ],
      avatar: ''
    }
  },
  mounted() {
    this.$http.getmyindex().then(res => {
      if (res.code !== -1) {
        this.userInfo = res.data?.info;
        this.userInfo.total = res.data?.total;
        localStorage.setItem('userInfo', JSON.stringify(this.userInfo));
        if (this.avatarlist[res.data?.info.headpic]?.url) {
          this.avatar = this.avatarlist[res.data?.info.headpic].url
          return
        }
        if (res.data?.info.headpic === '') {
          this.avatar = this.avatarlist[1].url
          return
        }
        if (res.data?.info.headpic) {
          this.avatar = this.$baseUrl + res.data?.info.headpic
        }
      }
    });
  },
  computed: {

  },
  methods: {
    goto(url) {
      if (!url) {
        this.$dialog.confirm({
          message: this.$t('user.t44'),
          confirmButtonText: this.$t('user.t42'),
          cancelButtonText: this.$t('user.t43')
        })
          .then(() => {
            // on confirm
            localStorage.removeItem('userString');
            localStorage.removeItem('uid');
            localStorage.removeItem('userInfo');
            localStorage.removeItem('token');
            this.$router.push('/login');
          })
          .catch(() => {
            // on cancel
          });
        return
      }
      // if (url == '/bankcard') {
      //   var info = JSON.parse(localStorage.getItem('userInfo'))
      //   if (info?.pwd2) {
      //     this.$router.push(url)
      //   } else {
      //     this.$toast.fail(this.$t('user.t50'))
      //   }
      //   return
      // }
      // if (url == '/withdraw') {
      //   this.$http.getBindBank().then(res => {
      //     if (res.data.info?.id) {
      //       this.$router.push(url);
      //     } else {
      //       this.$toast.fail(this.$t('user.t67'));
      //       setTimeout(() => {
      //         this.$router.push('/bankcard');
      //       }, 1000);
      //     }

      //   })
      //   return
      // }
      this.$router.push(url)
    }
  },
}
</script>
<style lang='less' scoped>
.user {

  .userinfo {
    margin-top: .4rem;
    // padding-top: 1.44rem;
    padding-left: .4rem;
    padding-right: .4rem;

    .userbody {
      background-color: #121212;
      color: #fff;
      border-radius: .2rem;
      border: .06rem solid #333;
      box-sizing: border-box;

      .top {
        display: flex;
        // background: linear-gradient(135deg, #DD585CFF 0%, #D44246 100%);

        border-top-left-radius: .2667rem;
        border-top-right-radius: .2667rem;
        // margin-top: 1rem;
        padding: .4rem;
        color: #fff;

        .avatar {
          width: 1.6rem;
          height: 1.6rem;
          padding-right: .4rem;
          box-sizing: content-box;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .right {
          .phone {
            font-size: .5333rem;
          }

          .code {
            display: flex;
            align-items: center;
            font-size: .4267rem;

            span {
              margin-right: .2667rem;
            }

            .material-icons {
              font-size: .4267rem;
            }
          }
        }
      }

      .center {
        border-top-left-radius: .2667rem;
        border-top-right-radius: .2667rem;
        // border-bottom: 1px solid #dee2e6;
        padding: .4rem;
        // background-color: #fff;
        margin-top: -0.2667rem;
        display: flex;
        justify-content: space-between;

        .balance {
          .price {
            font-size: .8rem;
          }

          .text {
            font-size: .4267rem;
          }
        }

        .btn {
          width: 1.44rem;
          height: 1.44rem;
          border-radius: 50%;
          background-color: #121212;
          color: #fff;
          border: .06rem solid #fff;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .bottom {
        padding: .32rem .4rem;
        // background-color: #fff;
        border-bottom-left-radius: .2667rem;
        border-bottom-right-radius: .2667rem;
        display: flex;
        justify-content: space-between;


        .item {
          width: 50%;
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;

          &:first-child {
            border-right: 1px dashed rgba(0, 0, 0, 0.1);
          }

          .text {
            font-size: .32rem;
          }

          .price {
            font-size: .4267rem;
          }
        }
      }
    }
  }

  .list {
    margin-top: .64rem;
    padding: .4rem;

    .item {
      padding: .2rem;
      display: flex;
      align-items: center;
      background-color: rgba(255, 255, 255, 0.1);
      margin-bottom: .4rem;
      border-radius: .3rem;

      &:last-child {
        .icon {
          background: #fff;

          .material-icons {
            color: red;
          }
        }
      }

      .icon {
        border-radius: .2667rem;
        // background: linear-gradient(135deg, #DD585CFF 0%, #D44246 100%);
        background-color: #121212;
        width: 1.3333rem;
        height: 1.3333rem;
        display: flex;
        align-items: center;
        justify-content: center;

        .material-icons {
          font-size: .64rem;
          color: #fff;
        }
      }

      .r {
        padding-left: .4rem;
        flex: 1;

        .txt {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: .4267rem;
          color: #fff;
        }
      }
    }
  }

  .green {
    // color: #00BE7D;
    color: #fff;
  }

  .orange {
    // color: #F16060;
    color: #fff;

  }

  ::v-deep {
    .van-radio {
      margin-bottom: .2133rem;
    }

    .van-radio__label {
      font-size: .32rem;
    }

    .van-nav-bar {
      color: #fff;
      height: 100%;
      background: #121212;

      .van-nav-bar__content {
        height: 100%;

        .van-ellipsis {
          overflow: inherit;
        }
      }
    }
  }
}
</style>
